import { render, staticRenderFns } from "./OurTenants.vue?vue&type=template&id=3bb1de0a&"
import script from "./OurTenants.vue?vue&type=script&lang=js&"
export * from "./OurTenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports